import { ERROR_GENERAL } from '../../../../shared/constants';

const errorInterceptor = [
  (response) => response,
  (error) => {
    const { data } = error.response ?? {};

    // Errors occuring in app controllers contain `message` (see ExceptionHandler). Errors
    // occuring in Devise contain `error`.
    const errorMessage = data?.message || data?.error || ERROR_GENERAL;
    const apiError = new Error(errorMessage);

    apiError.code = data?.code;

    return Promise.reject(apiError);
  },
];

export default errorInterceptor;
